import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type TextLinkProps = {
  to: string;
  children: ReactNode;
  tone?: "accent" | "dark" | "light";
  onClick?: () => void;
  className?: string;
};

const tones = {
  accent: "text-brand-blue hover:text-brand-blueDark",
  dark: "text-ink-primary hover:text-brand-blue",
  light: "text-brand-darkText hover:text-white"
};

export function TextLink({ to, children, tone = "accent", onClick, className = "" }: TextLinkProps) {
  return (
    <Link
      className={`group inline-flex items-center gap-2 rounded-md text-sm font-bold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-[3px] ${tones[tone]} ${className}`}
      to={to}
      onClick={onClick}
    >
      {children}
      <ArrowRight className="rtl-flip h-4 w-4 transition-transform group-hover:translate-x-1 group-focus-visible:translate-x-1" aria-hidden="true" />
    </Link>
  );
}
